import Spinner from '@/components/atom/Spinner';
import { LoaderContainer } from '@/components/molecules/Loader/styles';

const Loader = (props: { size?: number }) => {
  return (
    <LoaderContainer>
      <Spinner size={props.size} />
    </LoaderContainer>
  );
};
export default Loader;
